import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { Outlet } from "react-router";
import { Modals } from "../components/Modals.tsx";
import { useScrollToTop } from "../util/ScrollToTop.ts";
import { Footer } from "../components/Footer.tsx";
import { TopNav } from "../components/TopNav.tsx";
import { MenuDrawer } from "../components/MenuDrawer.tsx";
import { DrawerHeader } from "../components/styled/DrawerHeader.tsx";
import { Main } from "../components/styled/Main.tsx";
import { useMenuDrawer } from "../util/useMenuDrawer.ts";

const NavigationContainer = () => {
  useScrollToTop();
  const { open, handleDrawerOpen, handleDrawerClose } = useMenuDrawer();

  return (
    <Box sx={{ display: "flex" }} padding={2}>
      <TopNav open={open} handleDrawerOpen={handleDrawerOpen} />
      <MenuDrawer open={open} handleDrawerClose={handleDrawerClose} />
      <Main open={open}>
        <Box padding={3}>
          <DrawerHeader />
          <Outlet />
          <Modals />
          <Divider variant={"fullWidth"} sx={{ mt: 4 }} />
          <Footer />
        </Box>
      </Main>
    </Box>
  );
};

export default NavigationContainer;
